let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dh53L")).then(() => parcelRequire('9cVqz'));